import $ from 'jquery';

$(document).ready(() => {
  const $fancyboxSelector = $('[data-fancybox]');

  if (!$fancyboxSelector.length) {
    return;
  }

  require.ensure(['@fancyapps/fancybox/dist/jquery.fancybox'], (require) => {
    require('@fancyapps/fancybox/dist/jquery.fancybox');

    $fancyboxSelector.fancybox();
  });
});
